import AudienceNameView from './AudienceName.View';

const AudienceName = () => <AudienceNameView />;

export default AudienceName;
